import Button from "./partials/Button";

const Contact = () => {
  return (
    <div className="px-8 font-inter text-white xl:px-20 2xl:px-60 rounded-b-3xl z-1 pb-20 bg-bg-primary">
      <h1 className="text-2xl md:text-5xl font-black pb-12">CONTACT US</h1>
      <div>
        <div className="grid grid-cols-3">
          <p className="text-xs"></p>
          <div className="grid gap-y-5 col-span-2 sm:col-span-1">
            <h1 className="text-base sm:text-xl md:text-xl lg:text-xl">
              Looking to grow your business
            </h1>
            <div className="w-[150px] md:w-3/4 lg:w-4/5">
              <Button buttonTitle="Let's Connect!" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
